module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h2', {
    staticClass: "chapterhead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "ToC3"
  }, [_c('span', {
    attrs: {
      "href": "#/cover#credits",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Imprint")])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "ToC3"
  }, [_c('span', {
    attrs: {
      "href": "#/cover#dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1"
    }
  }, [_vm._v("Preface")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter2"
    }
  }, [_vm._v("Foreword")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter3"
    }
  }, [_vm._v("Buffalo, Wings, and a Prayer")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter4"
    }
  }, [_vm._v("A New Life Out West")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter5"
    }
  }, [_vm._v("Changes, Challenges, and Choices")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Innocence Interrupted")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Highs and Lows of High School")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Escaping CP Land through TV Land")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting in the Wings of College")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sneaking into the Store and Stealing the Spotlight")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My First “Funny Business” Manager")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Another Suitcase, Another Hall")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nice Dreams")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Out of the Closet, Onto a Pedestal")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Big Dreams, Dark Shadows, and Frolicking in Between")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breaking Up Is Hard to Do")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Three Faces of Geri: Jewell, Warner, and Tyler")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Touring with “Geri”")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Sesame Street to 1600 Pennsylvania Avenue")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The People You Meet on the Way Down")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Amazing Decade of Making Lemonade")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard, My Ex-Husband")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honesty Within")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building on a Shaky Foundation")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finding My Way Back Home")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Ground Zero")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Three Ds: Divorce, Deadwood, and Determination")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thank You")])])])]), _vm._v(" "), _c('div', [_c('div', [_c('p', {
    staticClass: "ToC1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Section")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ac24c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 60
// module chunks = 0